export const NEWSLETTER_MESSAGE = {
  subscribed: 'wysłaliśmy zniżkę',
  emailIsTaken: 'wpisany email jest już wykorzystany',
  invalidEmail: 'wpisany email jest niepoprawny',
  emptyEmail: 'wpisz adres email'
};